import React from "react";
import {
  FaFileAlt,
  FaHardHat,
  FaCalendarAlt,
  FaArrowRight,
  FaCheckCircle,
  FaClock,
  FaExclamationTriangle,
} from "react-icons/fa";

export default function WorkPermitCard({ permit, onClick }) {
  // Color scheme
  const eleghoBlue = "#363062";
  const eleghoGreen = "#8FCD00";

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return eleghoGreen; // Green
      case "pending":
        return "#FFA500"; // Orange
      case "returned":
        return "#F44336"; // Red
      default:
        return eleghoBlue; // Blue
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return <FaCheckCircle />;
      case "pending":
        return <FaClock />;
      case "returned":
        return <FaExclamationTriangle />;
      default:
        return <FaClock />;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div
      className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden transition-all hover:shadow-md hover:translate-y-[-2px] cursor-pointer"
      onClick={() => onClick(permit.id)}
    >
      <div className="p-4">
        <div className="flex justify-between items-start mb-2">
          <div className="text-sm font-medium text-[#363062]">
            {permit.identifier}
          </div>
          <div
            className="flex items-center px-2 py-1 rounded-full text-xs font-medium gap-1.5"
            style={{
              backgroundColor: `${getStatusColor(permit.status)}15`,
              color: getStatusColor(permit.status),
            }}
          >
            <span className="text-xs">{getStatusIcon(permit.status)}</span>
            {permit.status || "Unknown"}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-3">
          <div className="flex items-center gap-1.5">
            <FaFileAlt className="text-gray-400 flex-shrink-0" />
            <span className="font-medium">#{permit.id}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <FaHardHat className="text-gray-400 flex-shrink-0" />
            <span>{permit.workPermitType}</span>
          </div>
        </div>

        {/* Details Section */}
        <div className="mt-2 pt-2 border-t border-gray-100">
          <div className="grid grid-cols-2 gap-1 mb-1">
            <div className="text-xs text-gray-500">Name:</div>
            <div className="text-xs font-medium">{permit.name}</div>

            <div className="text-xs text-gray-500">Duration:</div>
            <div className="text-xs font-medium">{permit.duration} days</div>

            <div className="text-xs text-gray-500">Workers:</div>
            <div className="text-xs font-medium line-clamp-1">
              {permit.workers || "N/A"}
            </div>
          </div>

          <div className="text-xs text-gray-500 mt-2">Description:</div>
          <div className="text-xs line-clamp-2 mt-0.5">
            {permit.description}
          </div>
        </div>

        {/* Comments Count */}
        {permit.comments && permit.comments.length > 0 && (
          <div className="mt-2 pt-2 border-t border-gray-100">
            <div className="flex items-center justify-between">
              <span className="text-xs text-gray-500">Comments:</span>
              <span className="text-xs font-medium bg-gray-100 px-2 py-0.5 rounded-full">
                {permit.comments.length}
              </span>
            </div>
          </div>
        )}
      </div>
      {/* Footer with View Details */}
      <div className="flex justify-between items-center py-2 px-4 bg-gray-50 border-t border-gray-100">
        <div className="flex items-center text-xs text-gray-500">
          <FaCalendarAlt className="mr-1.5 w-3 h-3 text-gray-400" />
          {formatDate(permit.createdAt)}
        </div>
        <div className="flex items-center text-xs font-medium text-[#363062]">
          View Details
          <FaArrowRight className="ml-1.5 w-3 h-3" />
        </div>
      </div>
    </div>
  );
}
